<template>
  <div class="leaseInfoStep">
    <QS-scroller-box>
      <!-- 订单信息 -->
      <div class="border mb16 mt16">
        <QS-column-box class="mt16" :column="3" :list="list" :source="source"  separator=":" />
      </div>

      <!-- 租赁信息 -->
      <QS-h4-title title="租赁信息"/>
      <!-- 确认租赁信息 -->
      <PersonalRentInfo
        ref="rentInfo"
        :planId="planId"
        @updateInfo="updateRentDateInfo"
        @plantIdChange="planIdChange"
        @updateRentPlanList="updateRentPlanList"
        @tranDepositChange="tranDepositChange"
        :showDeposit="true"
        :deposit="deposit"
        :forbiddenEndDate="forbiddenEndDate"
        :defaultRentInfo="defaultRentInfo"
      />

      <!-- 司机合作模式组件 -->
      <DriverCooperationRules
        ref="driverCooperRef"
        :rentDateInfo="rentDateInfo"
        :payPlanFee="payPlanFee"
        :sceneType="'signContract'"
        v-if="rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
        @autoAnchor="autoAnchor"
      />

      <!-- 租赁信息文本展示和支付计划表格 -->
      <div v-else>
        <QS-h4-title title="租赁账单" />
        <RentPlanConfig
          ref="rentLeasePlanInfo"
          :rentDateInfo="rentDateInfo"
          :defaultTableData="feeTableData"
          :scene="SCENE_TYPE.SIGN_CONTRACT"
          :configDisabled="configDisabled"
          :depositConfig="depositConfig"
          @autoAnchor="autoAnchor"
          @rentCategoryType="handleRentLeasePlanInfo"
          @tableDataChange="tableDataChange"
        >
          <form-text-box
            :dataList="rentLeasePlan_formConfig"
            :model="rentDateInfo"
            :column="4"
          />
        </RentPlanConfig>
      </div>

      <!-- 按钮 -->
      <template slot="bottomAction">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          :loading="btnLoading"
          @click="confirm"
        >{{ submitText }}</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import { orderAccruedplanvalidAccruedPlanAmountApi } from '@/api/domain/orders'
import { getRentOrderDetail } from '@/api/domain/underLease'
import DriverCooperationRules from '@/components/DriverCooperationRules'
import PersonalRentInfo from '@/components/RentPlanConfig/PersonalRentInfo/index.vue'
import RentPlanConfig from '@/components/RentPlanConfig/index.vue'
import { rentLeasePlan_origin_formConfig } from '@/pages/orders/signContract/add/personalSignContract/nodeComponents/CreateOrderInfo/components/config.js'
import { CATEGORY_CODE_MAP, CATEGORY_FEE_MAP, FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import { cloneDeep, isEmpty, omit } from 'lodash'
import { mapState } from 'vuex'
import { ORDER_TYPE } from '../const'

import { SCENE_TYPE } from '@/components/RentPlanConfig/config'

import { addition, formatNumberWithCommas } from '@/utils'

export default {
  name: 'PersonPlan',
  inject: {
    deposit: {
      default: () => ({}),
    },
    getOrderConfigInfo: {
      default: () => ({}),
    },
  },
  props: {
    orderType: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: '确认',
    }, // 提交按钮文字
    list: {
      type: Array,
      default: () => [],
    }, // 顶部基础信息展示列表
    source: {
      type: Object,
      default: () => ({}),
    }, // 顶部基础信息展示列表数据源
    params: {
      type: Object,
      default: () => ({}),
    }, // 提交所需要的其它参数
    submitApi: {
      type: Function,
      default: null,
    },
  },
  components: { PersonalRentInfo, RentPlanConfig, DriverCooperationRules },
  data() {
    return {
      SCENE_TYPE,
      CATEGORY_CODE_MAP,
      reqRentCategory: '',
      btnLoading: false,
      rentPlanList: [], // 方案列表
      planId: null, // 租赁方案ID
      rentDateInfo: {
        category: '', // 类别
        signDate: '', // 签署日期
        startStopDate: '', // 收款起止日期
        presentDays: '', // 赠送天数
        isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
        contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31
        rentPeriodText: '', // 租期文本(天数) eg: 共7天
        presentDaysText: '', // 赠送天数文本 eg: 0天
        allTotalAmount: '', // 总金额
        deposit: '', // 押金
        rentAmount: '', // 租金
        firstPayment: '', // 首付款
        fullPayment: '', // 全款
        otherAmount: '', // 其余收款项
      },
      payPlanFee: {},
      accruedPlanParamList: [],
      feeTableData: [],
      depositConfig: {}, // 用以接收PersonalRentInfo的押金配置，传给table组件
      defaultRentInfo: {
        isTranDeposit: 1,
      },
      // 是否回显过
      isModify: false,
    }
  },
  computed: {
    forbiddenEndDate() {
      // 服务端将两个字段（presentEntDate（赠送截止日期）、endDate（租赁周期截止日期））进行处理，处理结果以contractEndDate返回
      return this.source.contractEndDate
    },
    // 订单配置信息
    orderConfigInfo() {
      return (this.getOrderConfigInfo && this.getOrderConfigInfo()) || {}
    },
    ...mapState({
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
    // 支付计划表单展示区
    rentLeasePlan_formConfig() {
      let configData = rentLeasePlan_origin_formConfig
      let configDataCp = cloneDeep(configData)

      configData = configData.filter((i) => i.showItem.includes(this.rentDateInfo.rentCategory))
      const filterFeeNames = ['首付款', '租金', '全款']

      if (Number(this.rentDateInfo.rentCategory) === 2) {
        filterFeeNames.forEach((name) => {
          if (!this.feeTableData.some((i) => i.name === name)) {
            configDataCp.forEach((item) => {
              if (item.itemName === name && item.showItem.includes(2)) {
                const idx = item.showItem.findIndex((i) => i === 2)
                item.showItem.splice(idx, 1)
              }
            })
          }
        })
        configDataCp = configDataCp.filter((i) => i.showItem.includes(2))
        configData = configDataCp
      }
      return configData
    },
    configDisabled() { // 租赁方案配置是否要禁用
      if (!this.planId) {
        return false
      }
      return this.rentPlanList.some((item) => Number(this.planId) === Number(item.id))
    },
  },
  watch: {
    orderConfigInfo: {
      async handler(val) {
        if (!val || isEmpty(val)) return
        this.defaultRentInfo = {
          rentCategory: val.rentCategory, // 类别
          signDate: `${val.signDate} 00:00:00`, // 签署日期
          startStopDate: [`${val.startDate} 00:00:00`, `${val.endDate} 00:00:00`], // 收款起止日期
          presentDays: val.presentDays, // 赠送天数
          isTranDeposit: val.orderConfig?.depositTransfer, // 是否平移原订单押金 1-是 0-否
          carId: val.plateNo, // 车牌号
          modelId: val.modelId, // 车型
          planId: val.planId, // 租赁方案ID
          relatedOrderId: val.relatedOrderId, // 续约时的原单id
        }
        this.rentDateInfo.rentCategory = val.rentCategory // 类别
      },
      immediate: true,
    },
    params: {
      handler(val) {
        if (isEmpty(val)) return
        if (val.carId) {
          this.defaultRentInfo.carId = val.carId
        }
        if (val.plateNo) {
          this.defaultRentInfo.plateNo = val.plateNo
        }
        if (val.modelId) {
          this.defaultRentInfo.modelId = val.modelId
        }
        if (val.relatedOrderId) { // 续约时的原单id
          this.defaultRentInfo.relatedOrderId = val.relatedOrderId
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    planIdChange(planId) {
      this.planChange(planId)
    },
    planChange(id) {
      this.planId = id
      if (!id) {
        this.$refs.rentInfo.resetFormData()
      }
    },
    tranDepositChange(depositConfig) {
      this.depositConfig = depositConfig
    },
    updateRentPlanList(list) {
      this.rentPlanList = list
    },
    handleRentLeasePlanInfo(rentCategory) {
      this.reqRentCategory = rentCategory
    },
    async updateRentDateInfo(rentInfoParams, feeTableData, from) {
      this.reqRentCategory = rentInfoParams.rentCategory
      this.rentDateInfo = {
        ...this.rentDateInfo,
        ...omit(rentInfoParams, ['allTotalAmount', 'deposit', 'rentAmount', 'firstPayment', 'fullPayment', 'otherAmount']),
      }

      this.payPlanFee = rentInfoParams.payPlanFee


      /**
       * 为了区分是取接口的数据还是取当前页面的数据，加入了事件标识，如果带有该标识，则一定是覆盖当前页面的数据，同时，由于
       */
      if (from === 'fromEvent') {
        this.isModify = true
        this.feeTableData = feeTableData
        this.tableDataChange(feeTableData)
      } else {
        this.feeTableData = feeTableData
      }

      if (!this.isModify) {
        if (isEmpty(this.orderConfigInfo)) {
          this.feeTableData = feeTableData
          return
        }
        // 从Store里取出费项的配置列表
        const feeCategoryName = CATEGORY_FEE_MAP[this.orderConfigInfo.rentCategory]
        if (isEmpty(this[feeCategoryName])) {
          await this.$store.dispatch('getFeeList', { type: feeCategoryName })
        }
        // 合并费项配置列表
        this.feeTableData = this.orderConfigInfo.orderAccruedPlans?.map((item) => {
          const feeCategories = this[feeCategoryName]
          const fee = feeCategories.find((i) => i.code === item.fundType)
          return {
            ...item,
            name: item.fundTypeName,
            required: fee.required, // 是否必填 boolean
            isConfirm: true,
            toast: fee.toast,
            isSelectScheme: Boolean(this.rentDateInfo.isTranDeposit),
            amount: item.planAmount,
          }
        })
      }
    },
    autoAnchor(toastFlag) {
      this.$refs.rentInfo.autoAnchorPoint(toastFlag)
    },
    // 获取个人订单信息
    async getPersonalOrderDetail(orderId, callback) {
      const res = await getRentOrderDetail({
        orderId,
      })
      if (!res) return
      const { code, data } = res
      if (code === 1 && data) {
        callback && callback(data)
      }
    },
    // 提交
    async confirm() {
      const params = await this.getParams()
      if (!params) {
        return
      }
      if (this.reqRentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        orderAccruedplanvalidAccruedPlanAmountApi({
          accruedPlanParamList: [...this.accruedPlanParamList],
          rentCategory: this.reqRentCategory,
        }).then((res) => {
          if (res?.code === 1) {
            this.handlersubmit(params)
          }
        })
      } else {
        this.handlersubmit(params)
      }
    },
    handlersubmit(params) {
      this.btnLoading = true

      // 批量续约提交时需要页面loading展示
      let screenLoading
      if (params.carInfoList && params.carInfoList.length > 1) {
        screenLoading = this.$loading({
          spinner: 'el-loading-spinner',
          background: 'rgba(255, 255, 255, 0.9)',
          lock: true,
        })
      }
      // 更新订单
      if (!isEmpty(this.orderConfigInfo)) {
        params.orderId = this.orderConfigInfo.orderId
      }
      this.submitApi(params).then((res) => {
        if (res.code !== 1) return
        if (this.orderType !== ORDER_TYPE.Personal) {
          this.$message.success('创建成功')
        }
        // 个人订单发起续约成功后需要重新拉取订单信息
        if (this.orderType === ORDER_TYPE.Personal && res?.data?.id) {
          this.getPersonalOrderDetail(res.data.id, (data) => {
            this.$emit('orderCreateSuccess', data)
          })
        } else {
          this.$emit('orderCreateSuccess', res.data)
        }
      }).catch((error) => {
        this.btnLoading = false
        if (error.code === 22049) {
          this.$message.error('租赁方案已下架，请重新选择租赁方案')
        }
      }).finally(() => {
        this.btnLoading = false
        screenLoading && screenLoading.close()
      })
    },
    // 获取提交参数
    async getParams() {
      const returnData = false
      const leaseInfoParams = this.$refs.rentInfo.getFormData()
      if (!leaseInfoParams) {
        return returnData
      }
      let payPlanFee = null
      let rentLeasePlanInfoParams = null

      if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        // 获取司机合作模式表单
        payPlanFee = await this.$refs.driverCooperRef.getFormData()
        if (!payPlanFee) {
          this.$message.error('请填写司机规则带有红色 * 的内容')
          return
        }
      } else {
        rentLeasePlanInfoParams = this.$refs.rentLeasePlanInfo.getFormData()
        // 针对押金做单独判断，押金的账单周期必须手填，从租赁方案的配置中带不过来
        if (this.yajinDidNoFile(rentLeasePlanInfoParams)) {
          this.$message.error('请将【押金】费项配置完成')
          return
        }
        if (!rentLeasePlanInfoParams) {
          return returnData
        }
        this.accruedPlanParamList = rentLeasePlanInfoParams.map((item) => {
          return { feeType: item.fundType, feeAmount: item.totalAmount }
        })
      }

      const { rentCategory, signDate, startStopDate, presentDays, isTranDeposit, planId } = leaseInfoParams
      const params = {
        rentCategory,
        signDate,
        startDate: startStopDate[0],
        endDate: startStopDate[1],
        presentDays,
        orderConfig: {
          depositTransfer: isTranDeposit,
        },
        payPlanFee,
      }
      return {
        ...params,
        ...this.params,
        planId: planId ?? this.params.planId,
        relatedType: 4,
        orderAccruedPlans: rentLeasePlanInfoParams || [],
      }
    },
    // 取消
    cancel() {
      this.$confirm('取消后可在「订单续约」列表继续操作订单确认流程，点击确定返回列表', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$router.back()
        this.$refreshBack(false)
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {})
    },
    // 配置区数据变化
    tableDataChange(value) {
      const tableData = value
      // 金额展示逻辑，如果没有配置，则展示 '--'
      // ② (押金、租金)或(首付款)，其余收款项
      const depositFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.YA_JIN) // 2-押金
      if (depositFeeData) {
        this.rentDateInfo.deposit = depositFeeData.isConfirm ? `${formatNumberWithCommas(depositFeeData?.totalAmount || 0)} 元` : '--'
      }
      const rentAmountFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.ZU_JIN) // 1-租金
      if (rentAmountFeeData) {
        const rentAmount = rentAmountFeeData.payPlanType !== 2 ? `${formatNumberWithCommas(rentAmountFeeData?.totalAmount || 0)} 元` : `${rentAmountFeeData?.totalAmount || 0}元`
        this.rentDateInfo.rentAmount = rentAmountFeeData.isConfirm ? rentAmount : '--'
      }
      const firstPaymentFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) // 24-首付款
      if (firstPaymentFeeData) {
        this.rentDateInfo.firstPayment = firstPaymentFeeData.isConfirm ? `${formatNumberWithCommas(firstPaymentFeeData?.totalAmount || 0)} 元` : '--'
      }
      const fullPaymentFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN) // 15-全款
      if (fullPaymentFeeData) {
        this.rentDateInfo.fullPayment = fullPaymentFeeData.isConfirm ? `${formatNumberWithCommas(fullPaymentFeeData?.totalAmount || 0)} 元` : '--'
      }
      // 其余收款项
      const otherTableFeeList = tableData.filter((item) => { // 1-租金 2-押金 15-全款 24-首付款
        return (Number(item.fundType) !== FEE_CODE_MAP.ZU_JIN &&
          Number(item.fundType) !== FEE_CODE_MAP.YA_JIN &&
          Number(item.fundType) !== FEE_CODE_MAP.QUAN_KUAN &&
          Number(item.fundType) !== FEE_CODE_MAP.SHOU_FU_KUAN)
      })
      const otherTableFeeNotConfirmed = otherTableFeeList.every((i) => i.isConfirm === false)
      if (otherTableFeeNotConfirmed) {
        this.rentDateInfo.otherAmount = '--'
      } else {
        const otherTableFeeTotalAmount = otherTableFeeList.reduce((sum, item) => {
          sum = addition(sum, item?.totalAmount || 0)
          return sum
        }, 0)
        this.rentDateInfo.otherAmount = `${formatNumberWithCommas(otherTableFeeTotalAmount)} 元`
      }
    },
    yajinDidNoFile(tableData) {
      const YA_JIN = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.YA_JIN)
      const flag = YA_JIN?.items?.some((v) => !v.startCycleDate || !v.endCycleDate)
      return YA_JIN?.payMode === 11 && flag
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .border{
    padding:0 16px;
    box-sizing: border-box;
}
::v-deep .border .el-column-box{
  margin-bottom: 0;
}

.leaseInfoStep {
  ::v-deep .bottom-action-inner{
    width: 100%;
    bottom: 8px;
  }
}
</style>
